import { Injectable, signal } from '@angular/core';

export interface PageRefreshAction {
  loading: () => boolean;
  run: () => void;
}

@Injectable({ providedIn: 'root' })
export class PageRefresh {
  readonly current = signal<PageRefreshAction | null>(null);
}
